import { Column, SortSpec } from '../types'

const getValue = <T,>(row: T, col: Column<T>) => {
  if (col.accessor) return col.accessor(row)
  return (row as any)[col.key]
}

const cmp = (a: any, b: any) => {
  if (a === b) return 0
  if (a === null || a === undefined) return -1
  if (b === null || b === undefined) return 1
  if (typeof a === 'number' && typeof b === 'number') return a < b ? -1 : 1
  const as = String(a).toLowerCase()
  const bs = String(b).toLowerCase()
  return as < bs ? -1 : 1
}

export const applySorts = <T,>(rows: T[], columns: Column<T>[], sorts: SortSpec[]) => {
  if (!sorts || sorts.length === 0) return rows
  const colMap = new Map(columns.map(c => [c.key, c] as const))
  const active = [...sorts].sort((a, b) => a.order - b.order)

  const indexed = rows.map((r, idx) => ({ r, idx }))
  indexed.sort((A, B) => {
    for (const s of active) {
      const col = colMap.get(s.key)
      if (!col) continue
      const av = getValue(A.r, col)
      const bv = getValue(B.r, col)
      const c = cmp(av, bv)
      if (c !== 0) return s.dir === 'asc' ? c : -c
    }
    return A.idx - B.idx
  })
  return indexed.map(x => x.r)
}
